import React from 'react';
import styled from 'styled-components';

// Import logo images
import blackLogo from '../assets/images/2-removebg-preview.png';
import whiteLogo from '../assets/images/3-removebg-preview.png';
import fullNameLogo from '../assets/images/2-removebgreview.png';

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const LogoImage = styled.img`
  height: ${props => props.height || '40px'};
  width: auto;
`;

const Logo = ({ color = 'black', height = '40px', fullName = false }) => {
  // Select the appropriate logo based on color
  const logoSrc = color === 'white' ? whiteLogo : blackLogo;
  
  // Use the full name logo if requested
  const selectedLogo = fullName ? fullNameLogo : logoSrc;
  
  return (
    <LogoContainer>
      <LogoImage 
        src={selectedLogo} 
        alt="Platform0 Logo" 
        height={height}
      />
    </LogoContainer>
  );
};

export default Logo;
